module.exports = __webpack_public_path__ + "img/lightdou.1eec366b.png";